import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet-async";
import logo from "./logo.svg";
import "./App.css";
import "./Wolfstyle.css";



import ReactLoading from 'react-loading';
import axios from 'axios';

//toast
import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Game from "./Game";
import WolfLanding from "./WolfLanding";
import HomePage from "./HomePage";

function App() {


  const [loading, setLoading] = useState(true);
  const [showSubscribe, setShowSubscribe] = useState(false);

  //params
  const [msisdn, setMsisdn] = useState("");
  const [sourceIp, setSourceIp] = useState("");
  const [productId, setProductId] = useState("");
  const [txId, setTxId] = useState("");
  const [mktId, setMktId] = useState("");


  //product descriptions
  const [productName, setProductName] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productFrequency, setProductFrequency] = useState("");
  const [productFound, setProductFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    toast.dismiss();

    const urlParams = new URLSearchParams(window.location.search);
    const prodid = urlParams.get('productId');
    const transactionId = urlParams.get('txId');
    const marketerId = urlParams.get('mktId');



    if (prodid) {
      setProductId(prodid);
    }

    if (transactionId) {
      setTxId(transactionId);
    }

    if(marketerId){
      setMktId(marketerId);
    }


    if (productId != "") {

      getProduct(productId);

      let hashedMsisdn = "";

      //SUBSCRIBE 

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `https://api.mfilter.libroafrica.com/api/request/token/get-hash-token`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic M3ZkaDZnMGJiZ2syY3Njaml2Z2h0ZDcwbjY6MXRhMW1xaHRkNW9tNW1vMTM1bmcwbXA1cHY3bmxxOHZpZTE4djY4YjJvMDJldnR1MTdzZg=='
        }
      };

      axios.request(config)
        .then((response) => {
          if (response.data.status == "000") {
            //he token generated successfully
            let heToken = response.data.token;

            setSourceIp(response.data.ip);

            //get hashed msisdn
            let configFetchMasked = {
              method: 'get',
              maxBodyLength: Infinity,
              url: 'https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn',
              headers: {
                'X-App': 'he-partner',
                'X-MessageID': '1234',
                'X-Source-System': 'he-partner',
                'Authorization': 'Bearer ' + heToken
              }
            };

            axios.request(configFetchMasked)
              .then((response) => {
                const responseData = response.data; // Extracting the data from the response
                hashedMsisdn = responseData.ServiceResponse.ResponseBody.Response.Msisdn;

                console.log(hashedMsisdn);
                if (hashedMsisdn.length > 0) {

                  setMsisdn(hashedMsisdn);
                  setLoading(false);
                  setShowSubscribe(true);


                } else {
                  toast.error('🦄 Please activate your safaricom mobile data!', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                  });

                  setLoading(false);
                }
              })
              .catch((error) => {
                toast.error('🦄 Please activate your safaricom mobile data!', {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                  transition: Bounce,
                });
                setLoading(false);

              });
          }
        })
        .catch((error) => {
          toast.error('🦄 Something went wrong! Please try again in a few minutes or contact Support!', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });

          setLoading(false);


        });

    } else {

      toast.error('Missing product parameter', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      setLoading(false);


    }
  }, [productId])


  function getProduct(productId) {

    let success = false;

    //get hashed msisdn
    setLoading(true);
    setShowSubscribe(false);

    let config = {
      method: 'get',
      url: `https://api.mfilter.libroafrica.com/api/request/product?productId=${productId}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    };

    axios.request(config)
      .then((response) => {
        setProductName(response.data.productName);
        setProductPrice(response.data.price);
        setProductFrequency(response.data.frequency);

        setProductFound(true);

        success = true;
      })
      .catch((error) => {
        toast.error('🦄 Something went wrong! Product not found!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      });

    return success;
  }





  function generateConsent(msisdn, source_ip) {
    //get hashed msisdn
    setLoading(true);
    setShowSubscribe(false);

    let config = {
      method: 'get',
      url: `https://api.mfilter.libroafrica.com/api/request/wap-subscribe?hashed_msisdn=${msisdn}&ip=${source_ip}&agent=${navigator.userAgent}&productId=${productId}&txId=${txId}&mktId=${mktId}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    };

    axios.request(config)
      .then((response) => {
        if (response.data.status == "000") {
          window.location.href = response.data.consent_url;
        }
      })
      .catch((error) => {
        toast.error('🦄 Something went wrong! Please try again in a few minutes or contact Support!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });


      });
  }




  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<WolfLanding />} />
          <Route path="/game" element={<Game />} />
          <Route path="/sub" element={<HomePage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
